import { gql } from '@apollo/client'

const EDIT_INSURANCE_POLICY = gql`
  mutation EDIT_INSURANCE_POLICY(
    $insurancePolicy: ID!
    $holderName: String!
    $policyNumber: String!
    $coverageType: String
    $relationship: String
    $status: String
    $sponsorNumber: String
    $due: DateTime!
    $inception: DateTime
    $details: String
    $disabled: Boolean
    $priceList: ID
    $updatePatients: Boolean
  ) {
    editInsurancePolicy(
      insurancePolicy: $insurancePolicy
      holderName: $holderName
      policyNumber: $policyNumber
      coverageType: $coverageType
      relationship: $relationship
      status: $status
      sponsorNumber: $sponsorNumber
      due: $due
      inception: $inception
      details: $details
      disabled: $disabled
      priceList: $priceList
      updatePatients: $updatePatients
    ) {
      id
      holderName
      policyNumber
      coverageType
      relationship
      status
      sponsorNumber
      due
      inception
      details
      disabled
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      priceList {
        id
        name
      }
    }
  }
`

export default EDIT_INSURANCE_POLICY
